<mat-tab-group class="relative w-full h-full">
  <mat-tab [label]="'Gestione Workflow' | siaTranslate">
    <div class="flex flex-row w-full h-full">
      <f-flow
        class="h-full"
        [style.width]="
          isAdmin ? 'calc(100% - ' + sidebar.offsetWidth + 'px)' : '100%'
        "
        fDraggable
        (fCreateConnection)="onCreateConnection($event)"
        (fReassignConnection)="onConnectionDropped($event)"
        (fCreateNode)="onNodeAdded($event)"
        (fSelectionChange)="onSelectionChange($event)"
        (fLoaded)="fitToScreen()"
        [vCellSize]="30"
        [hCellSize]="30"
        [fCellSizeWhileDragging]="true"
        (fDragStarted)="hasDragged = true"
      >
        @if (isAdmin) {
          <f-selection-area style="opacity: 0.4"></f-selection-area>
        }

        <f-background>
          <f-rect-pattern [hSize]="30" [vSize]="30"></f-rect-pattern>
        </f-background>
        <f-canvas fZoom>
          @if (isAdmin) {
            <f-connection-for-create fBehavior="fixed" fType="segment">
            </f-connection-for-create>
          }

          <!-- <f-line-alignment [fAlignThreshold]="10"></f-line-alignment> -->

          <f-snap-connection
            [fSnapThreshold]="50"
            fType="segment"
          ></f-snap-connection>

          @for (
            connection of workFlowConfiguration.connections;
            track connection
          ) {
            <f-connection
              [fReassignDisabled]="!isAdmin"
              [fSelectionDisabled]="!isAdmin"
              [fOutputId]="connection.from"
              [fInputId]="connection.to"
              fBehavior="fixed"
              fType="segment"
              (ngInit)="fitToScreen()"
              [isLast]="true"
              [class.warning-connection]="
                connection.fromColor ??
                getParentConditionColor(connection, connection.to)
              "
              [fText]="connection.description"
              [class.executed-connection]="connection.executed"
              (click)="onConnectionClick(connection)"
            >
              <svg
                viewBox="0 0 700 700"
                fMarker
                [type]="eMarkerType.START"
                class="connection-marker"
                [height]="5"
                [width]="5"
                [refX]="5.8"
                [refY]="2.5"
                markerUnits="strokeWidth"
              >
                <circle cx="350" cy="350" r="350" />
              </svg>
              <svg
                viewBox="0 0 700 700"
                [type]="eMarkerType.SELECTED_START"
                fMarker
                class="connection-marker"
                [height]="5"
                [width]="5"
                [refX]="5.8"
                [refY]="2.5"
                markerUnits="strokeWidth"
              >
                <circle cx="350" cy="350" r="350" />
              </svg>
              <svg
                viewBox="0 0 6 7"
                fMarker
                [type]="eMarkerType.END"
                class="connection-marker"
                [height]="7"
                [width]="6"
                [refX]="2"
                [refY]="3.5"
                markerUnits="strokeWidth"
                orient="auto"
              >
                <path
                  d="M0.000391006 0L6 3.5L0.000391006 7L0.000391006 0Z"
                  [attr.fill]="
                    connection.fromColor
                      ? connection.fromColor
                      : getEnableConditionColor(connection, connection.to)
                  "
                />
              </svg>
              <svg
                viewBox="0 0 6 7"
                fMarker
                [type]="eMarkerType.SELECTED_END"
                class="connection-marker"
                [height]="7"
                [width]="6"
                [refX]="2"
                [refY]="3.5"
                markerUnits="strokeWidth"
                orient="auto"
              >
                <path
                  d="M0.000391006 0L6 3.5L0.000391006 7L0.000391006 0Z"
                  [attr.fill]="
                    connection.fromColor
                      ? connection.fromColor
                      : getEnableConditionColor(connection, connection.to)
                  "
                />
              </svg>
            </f-connection>
          }

          @for (action of workFlowConfiguration.actions; track action) {
            <div
              fNode
              fDragHandle
              [fNodeSelectionDisabled]="!isAdmin"
              [fNodeDraggingDisabled]="!isAdmin"
              [(fNodePosition)]="action.position!"
              [fNodeId]="action.id"
              [class.node-hover]="hovering()[action.id]"
              (mouseenter)="hoveringNode(action.id, true)"
              (mouseleave)="hoveringNode(action.id, false)"
              siaMatContextMenu
              [matMenuTrigger]="isAdmin ? contextMenuTrigger : null"
              (click)="onActionClick(action)"
              (contextmenu)="setActionForMenu(action, $event)"
              [class]="
                actionsInExecution()[action.id.toLowerCase()]
                  ? 'node-' + actionsInExecution()[action.id.toLowerCase()]
                  : ''
              "
            >
              <div
                fNodeInput
                [fInputMultiple]="true"
                [fInputConnectableSide]="'top'"
                fInputId="{{ action.id }}-t"
                class="top input"
              ></div>
              <div
                fNodeOutput
                [isSelfConnectable]="false"
                [fOutputMultiple]="true"
                [fOutputConnectableSide]="'top'"
                fOutputId="{{ action.id }}-t"
                class="top output"
              ></div>

              <div
                fNodeInput
                [fInputMultiple]="true"
                [fInputConnectableSide]="'bottom'"
                fInputId="{{ action.id }}-b"
                class="bottom input"
              ></div>
              <div
                fNodeOutput
                [isSelfConnectable]="false"
                [fOutputMultiple]="true"
                [fOutputConnectableSide]="'bottom'"
                fOutputId="{{ action.id }}-b"
                class="bottom output"
              ></div>

              <div
                fNodeInput
                [fInputMultiple]="true"
                [fInputConnectableSide]="'left'"
                fInputId="{{ action.id }}-l"
                class="left input"
              ></div>
              <div
                fNodeOutput
                [isSelfConnectable]="false"
                [fOutputMultiple]="true"
                [fOutputConnectableSide]="'left'"
                fOutputId="{{ action.id }}-l"
                class="left output"
              ></div>

              <div
                fNodeInput
                [fInputMultiple]="true"
                [fInputConnectableSide]="'right'"
                fInputId="{{ action.id }}-r"
                class="right input"
              ></div>
              <div
                fNodeOutput
                [isSelfConnectable]="false"
                [fOutputMultiple]="true"
                [fOutputConnectableSide]="'right'"
                fOutputId="{{ action.id }}-r"
                class="right output"
              ></div>

              <div
                class="flex items-center justify-center p-1 my-auto rounded-lg opacity-75"
                [style.background]="actionsBlocksObj()[action.type]?.color"
                [colorContrastAuto]="true"
                contrastMode="adaptive"
              >
                <mat-icon class="icon-sm">
                  {{ actionsBlocksObj()[action.type]?.icon }}
                </mat-icon>
              </div>
              <div class="flex flex-col overflow-hidden">
                <span class="text-sm font-medium text-outline">
                  {{ actionsBlocksObj()[action.type]?.typeDescription }}
                </span>
                <span class="text-ellipsis-2-lines text-[.5rem]">
                  {{ action.description }}
                </span>
              </div>
            </div>
          }

          <!-- <f-minimap [fMinSize]="1000"></f-minimap> -->
        </f-canvas>
        <f-minimap
          [fMinSize]="2000"
          class="absolute bottom-2 right-2"
        ></f-minimap>
      </f-flow>

      <div
        class="sia-side-panel h-full !w-1/4 md:!relative md:!right-0 md:min-w-[400px]"
        #sidebar
        [class.!hidden]="!isAdmin"
      >
        @if (isAdmin) {
          <mat-tab-group
            class="w-full h-full"
            [(selectedIndex)]="selectedTabIndex"
          >
            <mat-tab [label]="'Azioni' | siaTranslate">
              <div
                class="flex flex-row flex-wrap gap-2 p-2 overflow-auto hf-full"
              >
                @for (action of actionsBlocks(); track action) {
                  <!-- Blocco che descrive l'azione del workflow -->
                  <div
                    class="sia-hover flex w-[calc(50%-.25rem)] cursor-move items-center gap-2 overflow-hidden rounded-2xl border-[0.2px] border-solid border-[var(--node-border-color)] bg-[var(--node-background-color)] p-2"
                    fExternalItem
                    [fData]="action.type"
                  >
                    <div
                      class="flex items-center justify-center p-1 my-auto rounded-lg opacity-75"
                      [style.background]="action.color"
                      [colorContrastAuto]="true"
                      contrastMode="adaptive"
                    >
                      <mat-icon class="icon-sm">
                        {{ action.icon }}
                      </mat-icon>
                    </div>

                    <div>
                      <div>{{ action.typeDescription | siaTranslate }}</div>
                      <div class="text-xs text-outline text-ellipsis-2-lines">
                        {{ action.description | siaTranslate }}
                      </div>
                    </div>
                  </div>
                }
              </div>
              <!-- Legenda -->
              <div>
                <!-- Legenda -->
                <!-- <svg
                viewBox="0 0 700 700"
                fMarker
                [type]="eMarkerType.START"
                class="connection-marker"
                [height]="5"
                [width]="5"
                [refX]="5.8"
                [refY]="2.5"
                markerUnits="strokeWidth"
              >
                <circle
                  cx="350"
                  cy="350"
                  r="350"
                  [attr.fill]="
                    connection.toColor
                      ? connection.toColor
                      : getConnectionToColor(connection, connection.to)
                  "
                />
              </svg> -->
              </div>
            </mat-tab>
          </mat-tab-group>
        }
      </div>
    </div>

    @if (workflowInExecution().length > 0 && false) {
      <div
        class="absolute z-50 w-64 p-3 bg-white border border-gray-200 shadow-lg animate-slide-up bottom-4 left-4 rounded-2xl"
      >
        <div class="flex flex-row justify-between">
          <h3 class="mb-2 text-sm font-semibold text-gray-700">
            Workflow in esecuzione
          </h3>
          <span
            class="cursor-pointer material-symbols-outlined"
            (click)="closeWorkflowPopup()"
          >
            close
          </span>
        </div>

        <ul class="space-y-2">
          @for (wf of workflowInExecution(); track wf) {
            <li
              class="flex items-center justify-between p-2 text-sm transition rounded-lg surface"
              [class.!bg-ai-shade-2]="wf.status === 'executing'"
              [class.!text-ai-on-shade]="wf.status === 'executing'"
            >
              <span class="truncate">{{ wf.description }}</span>
              @if (wf.status === 'complete') {
                <span class="material-symbols-outlined text-success">
                  task_alt
                </span>
              } @else if (wf.status === 'pending') {
                <span class="material-symbols-outlined"> hourglass </span>
              } @else {
                <div class="relative progress-spinner-overrides">
                  <mat-spinner
                    [diameter]="20"
                    color="white"
                    class="progress-spinner-overrides"
                  ></mat-spinner>
                </div>
              }
            </li>
          }
        </ul>
      </div>
    }
  </mat-tab>

  @if (isAdmin) {
    <mat-tab label="Generale">
      <div class="flex flex-col w-full max-h-full gap-2 p-2 overflow-auto">
        <sia-accordion title="Impostazioni Base" [opened]="true">
          <div class="flex flex-row gap-2">
            <sia-text-box
              class="w-2/5"
              label="Nome Workflow"
              [(value)]="workFlowConfiguration.id"
              [disabled]="false"
            >
            </sia-text-box>
            <sia-text-box
              class="w-2/5"
              label="Descrizione del workflow"
              [(value)]="workFlowConfiguration.description"
              [disabled]="false"
            ></sia-text-box>
            <sia-check-box
              class="w-1/5"
              label="Abilitato"
              [(value)]="workFlowConfiguration.enabled"
              [disabled]="false"
            ></sia-check-box>
          </div>
        </sia-accordion>
        <sia-accordion title="Gestione Triggers" [opened]="true">
          <div class="flex flex-col gap-5">
            @for (
              trigger of workFlowConfiguration.triggers ?? [];
              track trigger;
              let triggerIndex = $index
            ) {
              <div
                class="relative flex flex-row flex-wrap w-full p-2 border-2 border-solid rounded-md"
              >
                <div class="flex w-[2%] items-center justify-center">
                  <button
                    class="text-red-500 hover:text-red-700"
                    (click)="deleteTrigger(triggerIndex)"
                    mat-icon-button
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                <div class="flex w-[95%] flex-row flex-wrap gap-2">
                  <div class="flex flex-row w-full gap-2">
                    <sia-select-box
                      [selectBoxOptions]="{
                        fixedDataSource: triggerTypes,
                        value: trigger.type,
                      }"
                      [value]="trigger.type"
                      (valueChanged)="manageTriggerActions($event, $index)"
                      [disabled]="false"
                      label="Tipo di Trigger"
                      info="Il trigger è l'evento che avvia il workflow. Ad esempio, un trigger può essere l'arrivo di un nuovo file in una cartella specifica."
                      class="w-1/2"
                    ></sia-select-box>
                    @if (
                      trigger.type == 'FolderWatcher' ||
                      trigger.type == 'FolderTemporized'
                    ) {
                      <select-box-multi
                        [selectBoxOptions]="{
                          fixedDataSource: fileTypes,
                        }"
                        [(value)]="trigger.fileTypes"
                        [disabled]="false"
                        label="Tipologia Files"
                        info="Estensioni dei file da monitorare. Lascia vuoto per monitorare tutti i tipi di file."
                        class="1/2"
                      ></select-box-multi>
                    }
                  </div>
                  <div class="flex flex-row w-full gap-2">
                    @if (
                      trigger.type == 'FolderWatcher' ||
                      trigger.type == 'FolderTemporized'
                    ) {
                      <sia-text-box
                        class="w-1/2"
                        label="Cartella da monitorare"
                        [(value)]="trigger.folderPath"
                        [disabled]="false"
                      ></sia-text-box>
                      <sia-check-box
                        class="w-1/2"
                        label="Includi sotto cartelle"
                        [(value)]="trigger.includeSubfolders"
                        [disabled]="false"
                      ></sia-check-box>
                    }
                  </div>

                  @if (trigger.type == 'FolderTemporized') {
                    <div class="flex flex-row flex-wrap w-full gap-2">
                      <sia-button
                        (click)="addTimeInterval(trigger)"
                        label="Aggiungi intervallo"
                      ></sia-button>
                      <div
                        class="flex flex-row flex-wrap w-full gap-2 p-2 border border-gray-300"
                      >
                        @if (
                          (trigger.configurationStartTime?.length ?? 0) > 0
                        ) {
                          @for (
                            triggerInterval of trigger.configurationStartTime;
                            track $index;
                            let i = $index
                          ) {
                            <div
                              class="flex flex-row items-center w-full gap-2"
                            >
                              <sia-time-box
                                class="w-1/3"
                                label="Orario di inizio"
                                [disabled]="false"
                                [(value)]="trigger!.configurationStartTime![i]"
                              ></sia-time-box>
                              <button
                                mat-icon-button
                                (click)="removeTimeInterval(trigger, i)"
                              >
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }

                  @if (trigger.type == 'HttpRequest') {
                    <sia-select-box
                      [selectBoxOptions]="{
                        fixedDataSource: httpUploadType,
                        value: trigger.uploadType,
                      }"
                      [(value)]="trigger.uploadType"
                      [disabled]="false"
                      label="Input HTTP"
                      info="Dato in input nella chiamata HTTP"
                      class="w-2/5"
                    ></sia-select-box>

                    @if (trigger.uploadType == 'file') {
                      <sia-text-box
                        class="w-2/5"
                        label="Cartella di upload"
                        [(value)]="trigger.uploadFilePath"
                        [disabled]="false"
                      ></sia-text-box>
                    }
                  }
                  @if (
                    trigger.type == 'SqlTemporized' ||
                    trigger.type == 'SqlWatcher'
                  ) {
                    <div class="flex flex-row w-full gap-2">
                      <sia-check-box
                        [label]="'isPostgres'"
                        [(value)]="isPostgres"
                      >
                      </sia-check-box>
                      <sia-select-box
                        class="w-full"
                        label="Database"
                        [selectBoxOptions]="{
                          fixedDataSource: databases,
                          value: trigger.connectionStringName,
                        }"
                        [(value)]="trigger.connectionStringName"
                      >
                      </sia-select-box>
                      @if (!isPostgres) {
                        <sia-select-box
                          class="w-full md:w-1/2"
                          label="Schema vista"
                          [(value)]="trigger.viewSchema"
                          [selectBoxOptions]="{
                            disableEmptyElement: false,
                            value: trigger.viewSchema,
                            dbKey: 'web.v_schemas',
                          }"
                        >
                        </sia-select-box>
                        <sia-select-box
                          class="w-full md:w-1/2"
                          label="Nome vista"
                          [(value)]="trigger.viewName"
                          [selectBoxOptions]="{
                            disableEmptyElement: false,
                            value: trigger.viewName,
                            dbKey: 'web.v_dbobjects',
                            foreignKey: trigger.viewSchema,
                          }"
                          [foreignKey]="trigger.viewSchema"
                        >
                        </sia-select-box>
                      } @else {
                        <sia-text-box
                          label="Schema"
                          class="w-full md:w-1/2"
                          [(value)]="trigger.viewSchema"
                        >
                        </sia-text-box>
                        <sia-text-box
                          label="Nome vista"
                          class="w-full md:w-1/2"
                          [(value)]="trigger.viewName"
                        >
                        </sia-text-box>
                      }
                    </div>
                  }
                  @if (trigger.type == 'SqlTemporized') {
                    <sia-button
                      (click)="addTimeInterval(trigger)"
                      label="Aggiungi intervallo"
                    ></sia-button>
                    <div
                      class="flex flex-row flex-wrap w-full gap-2 p-2 border border-gray-300"
                    >
                      @if ((trigger.configurationStartTime?.length ?? 0) > 0) {
                        @for (
                          triggerInterval of trigger.configurationStartTime;
                          track $index;
                          let i = $index
                        ) {
                          <div class="flex flex-row items-center w-full gap-2">
                            <sia-time-box
                              class="w-1/3"
                              label="Orario di inizio"
                              [disabled]="false"
                              [(value)]="trigger!.configurationStartTime![i]"
                            ></sia-time-box>
                            <button
                              mat-icon-button
                              (click)="removeTimeInterval(trigger, i)"
                            >
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        }
                      }
                    </div>
                  }
                  @if (
                    trigger.type == 'EmailWatcher' ||
                    trigger.type == 'OutlookEmailWatcher'
                  ) {
                    <div class="flex flex-row items-center w-full gap-2">
                      @if (trigger.type == 'EmailWatcher') {
                        @if (trigger.account) {
                          <sia-text-box
                            class="w-1/3"
                            [disabled]="true"
                            label="Email registrata"
                            [(value)]="trigger.account"
                          >
                          </sia-text-box>
                          <button mat-icon-button (click)="logout(trigger)">
                            <mat-icon>logout</mat-icon>
                          </button>
                        } @else {
                          <div class="flex flex-col w-1/3 gap-2">
                            <sia-google-auth-button
                              class="w-full"
                              [scopeType]="
                                'workflow-' + workFlowConfiguration.id
                              "
                              [client_id]="client_id"
                              (accountChanged)="trigger.account = $event"
                            >
                            </sia-google-auth-button>
                          </div>
                        }
                      } @else if (trigger.type == 'OutlookEmailWatcher') {
                        <div class="flex flex-col w-full gap-2">
                          @for (
                            account of trigger.accounts;
                            track $index;
                            let i = $index
                          ) {
                            <div class="flex flex-row items-center gap-2">
                              <sia-text-box
                                class="w-full"
                                label="Email da monitorare"
                                [(value)]="trigger.accounts[i]"
                              >
                              </sia-text-box>
                              <button
                                mat-icon-button
                                (click)="removeAccount(trigger, i)"
                              >
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          }
                          <sia-button
                            (click)="addAccount(trigger)"
                            label="Aggiungi email"
                            icon="add"
                          ></sia-button>
                          <sia-datetime-box
                            class="w-full"
                            [(value)]="trigger.startDate"
                            label="Data inizio monitoraggio"
                          ></sia-datetime-box>

                          @for (
                            domain of trigger.excludeDomain;
                            track $index;
                            let i = $index
                          ) {
                            <div class="flex flex-row items-center gap-2">
                              <sia-text-box
                                class="w-full"
                                label="Dominio da escludere"
                                [(value)]="trigger.excludeDomain![i]"
                              >
                              </sia-text-box>
                              <button
                                mat-icon-button
                                (click)="removeDomain(trigger, i)"
                              >
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          }
                          <sia-button
                            (click)="addDomain(trigger)"
                            label="Aggiungi dominio"
                            icon="add"
                          ></sia-button>
                          
                          

                        </div>
                        <div class="flex flex-row items-center gap-2">
                            <sia-text-box
                            class="w-full"
                            label="Query per domini da includere"
                            [(value)]="trigger.validDomainsOrEmailsQuery"
                          >
                          </sia-text-box>
                          <sia-text-box
                            class="w-full"
                            label="ConnectionString per domini da includere"
                            [(value)]="trigger.validDomainsOrEmailsConnectionStringName"
                          >
                          </sia-text-box>
                         </div>
                         
                       
                        }

                      <sia-text-box
                        class="w-1/3"
                        label="Percorso di salvataggio email"
                        [(value)]="trigger.filePath"
                      >
                      </sia-text-box>
                      <sia-text-box
                        class="w-1/3"
                        label="Nome della cartella da monitorare"
                        [(value)]="trigger.folderName"
                      >
                      </sia-text-box>
                    </div>
                  }
                </div>
              </div>
            }
            <sia-button
              (click)="addTrigger()"
              label="Aggiungi Trigger"
              icon="add"
            ></sia-button>
          </div>
        </sia-accordion>
      </div>
    </mat-tab>
  }

  <mat-tab label="Storico esecuzioni">
    <div class="w-full h-full" #grid>
      <sia-grid-with-actions
        [gridInformations]="{
          componentId: 'grid-workflow-history',
          guid: pageData?.guid,
        }"
        [pageData]="pageData"
        [gridHeight]="grid.offsetHeight"
        [allowViews]="false"
        [isMaterialGrid]="true"
      >
      </sia-grid-with-actions>
    </div>
  </mat-tab>
</mat-tab-group>

<mat-menu #actionMenu="matMenu">
  <ng-template matMenuContent>
    <button
      mat-menu-item
      mat-button
      class="error"
      (click)="deleteAction(actionForMenu!.id!)"
    >
      <mat-icon>delete</mat-icon>
      {{ 'Elimina' | siaTranslate }}
    </button>
  </ng-template>
</mat-menu>
<div
  #contextMenuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="actionMenu"
></div>
